import { getMaxEnumValue } from "../../../tools/EnumTools";

export enum WorkSortingFields {
    PRICE = "price",
    DISTANCE = "distance",
    START_FROM = "startFrom",
}

export enum WorkDefaultSortingFields {
    CREATED_AT = "createdAt",
}

export const MAX_WORK_SORTING_FIELDS = getMaxEnumValue(WorkSortingFields);
